import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=d5e93e12&scoped=true"
import script from "./commonDialog.vue?vue&type=script&lang=js"
export * from "./commonDialog.vue?vue&type=script&lang=js"
import style0 from "./commonDialog.vue?vue&type=style&index=0&id=d5e93e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e93e12",
  null
  
)

export default component.exports